import { jsx as r, jsxs as w } from "react/jsx-runtime";
import { useEffect as P } from "react";
import { useSortable as h } from "@dnd-kit/sortable";
import f from "classnames";
import { useTranslation as H } from "react-i18next";
import { Button as B, DotsMove as I } from "@forma/forma-ui-kit";
import v from "../FillProductsTableInput/index.js";
const L = "forma-filling__fill-products-table-rows__headRemove", S = "forma-filling__fill-products-table-rows__over", V = "forma-filling__fill-products-table-rows__rowTotal", E = "forma-filling__fill-products-table-rows__rowBody", C = "forma-filling__fill-products-table-rows__cell", M = "forma-filling__fill-products-table-rows__cellInput", j = "forma-filling__fill-products-table-rows__cellValue", D = "forma-filling__fill-products-table-rows__rowTotalPrice", W = "forma-filling__fill-products-table-rows__move", k = "forma-filling__fill-products-table-rows__rowHead", l = {
  headRemove: L,
  over: S,
  rowTotal: V,
  rowBody: E,
  cell: C,
  cellInput: M,
  cellValue: j,
  rowTotalPrice: D,
  move: W,
  rowHead: k
}, Q = () => {
  const { t } = H(), { setNodeRef: a, isOver: o, isSorting: c, node: e } = h({ id: "header" });
  return P(() => {
    const s = (e == null ? void 0 : e.current) && e.current.parentElement;
    if (!e.current || !s)
      return;
    const n = (d) => {
      const m = d.target;
      e.current && (e.current.style.left = `${m.scrollLeft}px`, e.current.style.width = `${m.offsetWidth}px`);
    };
    return s.addEventListener("scroll", n), e.current.style.left = `${s.scrollLeft}px`, e.current.style.width = `${s.offsetWidth}px`, () => {
      s.removeEventListener("scroll", n);
    };
  }, [e.current]), c ? /* @__PURE__ */ r("div", { className: f(l.headRemove, o && l.over), ref: a, children: t("uikit:drag_here_for_remove_line") }) : null;
}, U = ({ columns: t, colSpan: a }) => /* @__PURE__ */ r("tr", { className: l.rowHead, children: t.map(({ id: o, name: c, width: e }) => /* @__PURE__ */ r(
  "th",
  {
    className: l[`cell${o}`],
    style: { width: e },
    colSpan: a,
    children: c
  },
  o
)) }), X = ({
  id: t,
  item: a,
  columns: o,
  onApplyToAll: c,
  onChangeCell: e,
  colSpan: s
}) => {
  const { attributes: n, listeners: d, setNodeRef: m, transform: u, transition: g, isDragging: b } = h({ id: t }), y = {
    transform: u ? `translate3d(${u.x ? Math.round(u.x) : 0}px, ${u.y ? Math.round(u.y) : 0}px, 0)` : void 0,
    opacity: b ? "0.5" : "1",
    transition: g
  };
  return /* @__PURE__ */ r("tr", { id: t, className: f(l.rowBody, "fill-products-table-row"), style: y, ref: m, children: o.map(({ id: i, readOnly: p, type: x, isSimilar: T, canApplyToAll: N, width: R }, $) => /* @__PURE__ */ w(
    "td",
    {
      className: f(l.cell, p ? l.cellValue : l.cellInput),
      style: { width: R },
      colSpan: s,
      children: [
        p ? /* @__PURE__ */ r("span", { children: a[i] }) : /* @__PURE__ */ r(
          v,
          {
            id: i,
            productId: t,
            type: x,
            value: a[i],
            isSimilar: T,
            canApplyToAll: N,
            onChangeAll: (_) => c(i, _),
            onChangeItem: (_) => e(t, i, _)
          }
        ),
        $ === o.length - 1 && /* @__PURE__ */ r(B, { viewStyle: "textLight", size: "extraSmall", className: l.move, ...n, ...d, children: /* @__PURE__ */ r(I, {}) })
      ]
    },
    `${t}_${i}`
  )) });
}, Y = ({
  id: t,
  name: a,
  type: o,
  productsTotal: c,
  readOnly: e,
  colSpan: s,
  onChangeTotal: n
}) => /* @__PURE__ */ w("tr", { className: f(l.rowTotal, t === "totalPrice" && l.rowTotalPrice), children: [
  /* @__PURE__ */ r("td", { className: f(l.cellTotal), colSpan: s, children: a }),
  /* @__PURE__ */ r("td", { className: f(l.cellTotal, e ? l.cellTotalValue : l.cellInput), children: e ? /* @__PURE__ */ r("span", { children: c[t] }) : /* @__PURE__ */ r(
    v,
    {
      id: t,
      productId: "total",
      type: o,
      value: c[t],
      onChangeItem: (d) => n(t, d)
    }
  ) })
] });
export {
  Q as HeaderRemove,
  U as HeaderRow,
  X as ProductsRow,
  Y as ProductsTotalRow
};
